module.exports = __webpack_public_path__ + "static/media/a.d65a56ad.png";